import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import { FaCalendarAlt, FaUsers, FaCheckCircle, FaTimesCircle, FaFileInvoiceDollar, FaExternalLinkAlt, FaClipboardList } from 'react-icons/fa';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import CalendarioEventos from '../../components/CalendarioEventos';
import moment from 'moment';
import '../../css/financeiro-parcela-pagar.css';
import './Principal.css';
import { PERFIS_AEREO } from '../../util/malhaAereo';

export default function Principal() {
  const [estatisticas, setEstatisticas] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [itensPendentesNF, setItensPendentesNF] = useState([]);
  const [carregandoItensNF, setCarregandoItensNF] = useState(true);
  // NOVO: estado para O.S em aberto
  const [osEmAberto, setOsEmAberto] = useState([]);
  const [carregandoOsEmAberto, setCarregandoOsEmAberto] = useState(true);
  const token = localStorage.getItem('token');
  const perfil = localStorage.getItem('perfil');

  // Verifica se o usuário tem perfil de eventos
  const temPerfilEventos = () => {
    if (!perfil) return false;
    const perfis = perfil.toLowerCase().split(',');
    return perfis.some(p => p.trim().includes('evento'));
  };

  const history = useHistory();

  useEffect(() => {
    if (perfil === 'suplier') {
      history.replace('/evento');
      return;
    }

    // O Aéreo entra pela tela Aéreo, o painel dele.
    if (PERFIS_AEREO.includes(perfil)) {
      history.replace('/aereo');
      return;
    }

    if (perfil === 'backofficeinterno') {
      history.replace('/evento');
    }
  }, [history, perfil]);

  const buscarEstatisticas = useCallback(async (isMountedRef) => {
    try {
      setCarregando(true);
      const response = await api({
        method: 'get',
        action: '/evento/estatisticasUsuario',
        token: token,
      });

      // Verifica se o componente ainda está montado antes de atualizar o estado
      if (!isMountedRef || !isMountedRef.current) {
        return;
      }

      if (response.data.status === true) {
        setEstatisticas(response.data.data);
      }
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
    } finally {
      if (isMountedRef && isMountedRef.current) {
        setCarregando(false);
      }
    }
  }, [token]);


  const buscarItensPendentesNF = useCallback(async (isMountedRef) => {
    try {
      setCarregandoItensNF(true);
      const response = await api({
        method: 'get',
        action: '/orcamento/itensPendentesNotaFiscal',
        token: token,
      });

      // Verifica se o componente ainda está montado antes de atualizar o estado
      if (!isMountedRef || !isMountedRef.current) {
        return;
      }

      if (response.data.status === true) {
        setItensPendentesNF(response.data.data);
      }
    } catch (error) {
      console.error('Erro ao buscar itens pendentes de nota fiscal:', error);
    } finally {
      if (isMountedRef && isMountedRef.current) {
        setCarregandoItensNF(false);
      }
    }
  }, [token]);

  // NOVO: busca O.S em aberto (endpoint pode ser ajustado no backend)
  const buscarOsEmAberto = useCallback(async (isMountedRef) => {
    try {
      setCarregandoOsEmAberto(true);
      const response = await api({
        method: 'get',
        action: '/evento/osEmAberto',
        token: token,
      });

      // Verifica se o componente ainda está montado antes de atualizar o estado
      if (!isMountedRef || !isMountedRef.current) {
        return;
      }

      if (response.data.status === true) {
        setOsEmAberto(response.data.data || []);
      }
    } catch (error) {
      console.error('Erro ao buscar O.S em aberto:', error);
    } finally {
      if (isMountedRef && isMountedRef.current) {
        setCarregandoOsEmAberto(false);
      }
    }
  }, [token]);

  const navegarParaEventos = (tipo) => {
    const hoje = new Date();
    const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
    const usuarioId = localStorage.getItem('idUsuario');

    if (!usuarioId) {
      alert('Erro: ID do usuário não encontrado. Faça login novamente.');
      return;
    }

    let url = '/evento?';

    switch (tipo) {
      case 'mes_atual':
        if (estatisticas?.eventos_mes_atual === 0) {
          alert('Não há eventos para o mês atual.');
          return;
        }
        url += `dataInicial=${primeiroDiaMes.toISOString().split('T')[0]}&dataFinal=${ultimoDiaMes.toISOString().split('T')[0]}&responsavelagencia=${usuarioId}`;
        break;
      case 'ativos':
        if (estatisticas?.eventos_ativos === 0) {
          alert('Não há eventos ativos.');
          return;
        }
        url += `situacao=ativo&responsavelagencia=${usuarioId}`;
        break;
      case 'fechados':
        if (estatisticas?.eventos_fechados === 0) {
          alert('Não há eventos fechados.');
          return;
        }
        url += `situacao=fechado&responsavelagencia=${usuarioId}`;
        break;
      case 'total':
        if (estatisticas?.total_eventos === 0) {
          alert('Não há eventos cadastrados.');
          return;
        }
        // Para total, mostra todos os eventos onde o usuário é responsável
        url += `responsavelagencia=${usuarioId}`;
        break;
      default:
        url = '/evento';
    }

    history.push(url);
  };




  useEffect(() => {
    if (['suplier', 'backofficeinterno'].includes(perfil)) {
      return undefined;
    }

    const isMountedRef = { current: true };

    buscarEstatisticas(isMountedRef);
    buscarItensPendentesNF(isMountedRef);
    // NOVO: carregar O.S em aberto
    buscarOsEmAberto(isMountedRef);

    // Cleanup: marca como desmontado quando o componente for desmontado
    return () => {
      isMountedRef.current = false;
    };
  }, [buscarEstatisticas, buscarItensPendentesNF, buscarOsEmAberto, perfil]);

  const renderizarEstatisticas = () => {
    if (carregando) {
      return (
        <div className="fin-pp__card" style={{ padding: '32px 16px', textAlign: 'center' }}>
          <div className="fin-pp__spinner" role="status" aria-label="Carregando" />
          <p className="fin-pp__kpi-sub" style={{ marginTop: 12 }}>Carregando estatísticas...</p>
        </div>
      );
    }

    if (!estatisticas) {
      return (
        <div className="fin-pp__banner is-warn" role="alert">
          <span className="fin-pp__banner-ic"><FaCalendarAlt size={15} /></span>
          Não foi possível carregar as estatísticas de eventos.
        </div>
      );
    }

    const kpis = [
      {
        tipo: 'mes_atual',
        label: 'Eventos do mês atual',
        titulo: 'Clique para ver seus eventos do mês atual',
        icone: <FaCalendarAlt size={16} />,
        valor: estatisticas.eventos_mes_atual,
        tom: 'is-info',
        sub: estatisticas.mes_atual,
      },
      {
        tipo: 'ativos',
        label: 'Eventos ativos',
        titulo: 'Clique para ver seus eventos ativos',
        icone: <FaCheckCircle size={16} />,
        icTom: 'is-ok',
        valor: estatisticas.eventos_ativos,
        tom: 'is-ok',
        sub: 'Em andamento',
      },
      {
        tipo: 'fechados',
        label: 'Eventos fechados',
        titulo: 'Clique para ver seus eventos fechados',
        icone: <FaTimesCircle size={16} />,
        valor: estatisticas.eventos_fechados,
        tom: '',
        sub: 'Concluídos',
      },
      {
        tipo: 'total',
        label: 'Total de eventos',
        titulo: 'Clique para ver todos os seus eventos',
        icone: <FaUsers size={16} />,
        valor: estatisticas.total_eventos,
        tom: 'is-warn',
        sub: 'Todos os tempos',
      },
    ];

    return (
      <>
        <section className="fin-pp__kpis">
          {kpis.map(k => (
            <div
              key={k.tipo}
              className="fin-pp__kpi"
              style={{ cursor: 'pointer' }}
              title={k.titulo}
              onClick={() => navegarParaEventos(k.tipo)}
            >
              <div className="fin-pp__kpi-top">
                <span className="fin-pp__kpi-label">{k.label}</span>
                <span className={'fin-pp__kpi-ic ' + (k.icTom || '')}>{k.icone}</span>
              </div>
              <div className={'fin-pp__kpi-value ' + k.tom}>{k.valor}</div>
              <div className="fin-pp__kpi-sub">{k.sub}</div>
            </div>
          ))}
        </section>

        {/* Tabela de Itens Pendentes de Nota Fiscal - Apenas para perfil eventos */}
        {temPerfilEventos() && (
          <div className="fin-pp__card" style={{ marginTop: 18, overflow: 'hidden' }}>
            <div className="fin-pp__cphead" style={{ padding: '16px 18px 12px' }}>
              <span className="fin-pp__cphead-ic"><FaFileInvoiceDollar size={17} /></span>
              <div>
                <h3 className="fin-pp__cphead-title">Itens de orçamentos pendentes de nota fiscal</h3>
                <p className="fin-pp__cphead-sub">Aguardando lançamento da NF</p>
              </div>
              {!carregandoItensNF && itensPendentesNF.length > 0 && (
                <span className="fin-pp__cphead-pill is-warn">{itensPendentesNF.length} pendente(s)</span>
              )}
            </div>

            {carregandoItensNF ? (
              <div style={{ padding: '28px 16px', textAlign: 'center' }}>
                <div className="fin-pp__spinner" role="status" aria-label="Carregando" />
                <p className="fin-pp__kpi-sub" style={{ marginTop: 12 }}>Carregando itens pendentes...</p>
              </div>
            ) : (
              <div className="fin-pp__tblwrap">
                <table className="fin-pp__tbl" style={{ minWidth: 900, tableLayout: 'auto' }}>
                  <thead>
                    <tr>
                      <th>Evento</th>
                      <th>Item</th>
                      <th>Fornecedor</th>
                      <th style={{ width: 130, textAlign: 'right' }}>Valor (R$)</th>
                      <th style={{ width: 120, textAlign: 'center' }}>Vencimento</th>
                      <th style={{ width: 90, textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itensPendentesNF.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="fin-pp__empty">Nenhum item pendente de nota fiscal encontrado.</td>
                      </tr>
                    ) : itensPendentesNF.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <div className="fin-pp__cell-strong">{item.orcamento?.evento?.nome || 'N/A'}</div>
                          <div className="fin-pp__tbl-sub">{item.orcamento?.evento?.codigo || 'N/A'}</div>
                        </td>
                        <td>
                          <div className="fin-pp__cell-strong">{item.produto?.nome || 'N/A'}</div>
                          {item.observacaoFechamento && (
                            <div className="fin-pp__tbl-sub">{item.observacaoFechamento}</div>
                          )}
                        </td>
                        <td className="fin-pp__cell-muted">
                          {(() => {
                            // Verifica se existe fornecedor de pagamento com ID
                            if (item.fornecedorpagamento?.id) {
                              return item.fornecedorpagamento.nomefantasia || item.fornecedorpagamento.nome || 'A definir';
                            }
                            // Verifica se existe fornecedor com ID
                            if (item.fornecedor?.id) {
                              return item.fornecedor.nomefantasia || item.fornecedor.nome || 'A definir';
                            }
                            return 'A definir';
                          })()}
                        </td>
                        <td className="fin-pp__cell-num">
                          {(item.totalFechamento || 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.pagamentovencimento ? (
                            <span className="fin-pp__minitag is-warn">
                              {moment(item.pagamentovencimento).format('DD/MM/YYYY')}
                            </span>
                          ) : (
                            <span className="fin-pp__cell-muted">A definir</span>
                          )}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Link
                            to={{
                              pathname: `/cadastroOrcamento/${(item?.orcamento?.id ?? '')}`,
                              search: `?itemId=${item.id}`
                            }}
                            target="_blank"
                            className="fin-pp__btn fin-pp__btn--sm"
                            title="Ir para o orçamento"
                          >
                            <FaExternalLinkAlt size={13} />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* NOVO: Tabela de O.S em aberto - Apenas para perfil eventos */}
        {temPerfilEventos() && (
          <div className="fin-pp__card" style={{ marginTop: 18, overflow: 'hidden' }}>
            <div className="fin-pp__cphead" style={{ padding: '16px 18px 12px' }}>
              <span className="fin-pp__cphead-ic"><FaClipboardList size={17} /></span>
              <div>
                <h3 className="fin-pp__cphead-title">O.S em aberto</h3>
                <p className="fin-pp__cphead-sub">Eventos que ainda precisam de ordem de serviço</p>
              </div>
              {!carregandoOsEmAberto && (osEmAberto?.length ?? 0) > 0 && (
                <span className="fin-pp__cphead-pill is-warn">{osEmAberto.length} evento(s)</span>
              )}
            </div>

            {carregandoOsEmAberto ? (
              <div style={{ padding: '28px 16px', textAlign: 'center' }}>
                <div className="fin-pp__spinner" role="status" aria-label="Carregando" />
                <p className="fin-pp__kpi-sub" style={{ marginTop: 12 }}>Carregando O.S em aberto...</p>
              </div>
            ) : (
              <div className="fin-pp__tblwrap os-scroll">
                <table className="fin-pp__tbl" style={{ minWidth: 800, tableLayout: 'auto' }}>
                  <thead className="thead-sticky">
                    <tr>
                      <th>Evento</th>
                      <th style={{ width: 260 }}>Período</th>
                      <th style={{ width: 160, textAlign: 'center' }}>Dias p/ início</th>
                      <th style={{ width: 120, textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(osEmAberto?.length ?? 0) === 0 ? (
                      <tr>
                        <td colSpan={4} className="fin-pp__empty">Não há O.S em aberto no momento.</td>
                      </tr>
                    ) : osEmAberto.map((item, idx) => {
                      // tentar diferentes chaves de data vindas do backend
                      const inicioRaw = item.dataInicio || item.inicio || item.data_inicio || item.evento?.data;
                      const fimRaw = item.dataFim || item.fim || item.data_fim || item.evento?.dataTermino;
                      const nomeEvento = item.nome || item.evento?.nome || 'N/A';
                      const idEvento = item.idEvento || item.id || item.evento?.id;
                      const hasOS = item.hasOrdemServico === true || item.hasOrdemServico === 'true';
                      const dias = inicioRaw ? moment(inicioRaw).startOf('day').diff(moment().startOf('day'), 'days') : null;
                      const diasTexto = dias === null ? '—' : (dias < 0 ? 'Já iniciado' : `${dias} dia(s)`);
                      const handleCriarOsClick = () => {
                        if (!idEvento) return;
                        const payload = {
                          id: String(idEvento),
                          nome: nomeEvento,
                          data: inicioRaw ? moment(inicioRaw).format('YYYY-MM-DD HH:mm:ss') : null,
                          dataFim: fimRaw ? moment(fimRaw).format('YYYY-MM-DD HH:mm:ss') : null,
                        };
                        try {
                          localStorage.setItem('eventoSelecionado', JSON.stringify(payload));
                        } catch (e) {
                          // ignore storage errors
                        }
                      };
                      return (
                        <tr key={idx}>
                          <td>
                            <div className="fin-pp__cell-strong">{nomeEvento}</div>
                            <span className={'fin-pp__minitag ' + (hasOS ? 'is-ok' : 'is-warn')}>
                              {hasOS ? 'Com O.S' : 'Sem O.S'}
                            </span>
                          </td>
                          <td className="fin-pp__cell-muted">
                            {inicioRaw ? moment(inicioRaw).format('DD/MM/YYYY') : 'A definir'}
                            {' '}até{' '}
                            {fimRaw ? moment(fimRaw).format('DD/MM/YYYY') : 'A definir'}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span className={'fin-pp__minitag ' + (dias !== null && dias < 0 ? 'is-warn' : 'is-info')}>
                              {diasTexto}
                            </span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {idEvento ? (
                              <Link
                                to={`/cadastroEventoOrdemServico/${idEvento}`}
                                className="fin-pp__btn fin-pp__btn--sm"
                                title="Criar O.S"
                                onClick={handleCriarOsClick}
                              >
                                <FaExternalLinkAlt size={13} />
                              </Link>
                            ) : (
                              <span className="fin-pp__cell-muted">—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Card do Calendário */}
        <div className="fin-pp__card" style={{ marginTop: 18, padding: '16px 18px' }}>
          <div className="fin-pp__cphead">
            <span className="fin-pp__cphead-ic"><FaCalendarAlt size={17} /></span>
            <div>
              <h3 className="fin-pp__cphead-title">Calendário de eventos</h3>
              <p className="fin-pp__cphead-sub">Visão mensal dos seus eventos</p>
            </div>
          </div>
          <CalendarioEventos />
        </div>
      </>
    );
  };

  return (
    <ErpTemplate>
      <div className="main-content container-fluid fin-pp">
        <div className="fin-pp__head">
          <div>
            <h1 className="fin-pp__title">Estatísticas de Eventos</h1>
            <p className="fin-pp__subtitle">Resumo dos eventos sob sua responsabilidade</p>
          </div>
        </div>

        {renderizarEstatisticas()}
      </div>
    </ErpTemplate>
  );
}
